<div class="shared-modal-advanced-filter-container">

  <div class="modal-header">
    <div class="modal-toolbar">
      <div class="modal-title-container">
        <div>
          <div>{{ modalTitle }}</div>
          <span></span>
          @if (buttonCloseCross) {
            <app-shared-button
              (click)="onButtonPress('button-close')"
              [fill]="false"
              [colour]="'clear'"
              class="close-button">
              <app-display-icon [icon]="icons.close"></app-display-icon>
            </app-shared-button>
          }
        </div>
      </div>
    </div>
  </div>

  <div class="context-container">

    <aside class="list-container">
      @if (!lockCategoryTabs) {
        <div class="list-category-tabs" role="tablist" aria-label="Filter category">
          <button
            type="button"
            role="tab"
            class="list-category-tab"
            [class.active]="selectedGrid === advancedFilterGridGeneral"
            [attr.aria-selected]="selectedGrid === advancedFilterGridGeneral"
            [disabled]="getIsNewAdvancedFilterGroup"
            (click)="onCategoryTabClick(advancedFilterGridGeneral)">
            General Filters
          </button>
          <button
            type="button"
            role="tab"
            class="list-category-tab"
            [class.active]="selectedGrid === advancedFilterGridStockTake"
            [attr.aria-selected]="selectedGrid === advancedFilterGridStockTake"
            [disabled]="getIsNewAdvancedFilterGroup"
            (click)="onCategoryTabClick(advancedFilterGridStockTake)">
            Stock Take Filters
          </button>
        </div>
      }
      <div class="list-header">
        <span class="list-header-label">Saved Filters</span>
        <input
          [(ngModel)]="filterSearchTerm"
          class="list-search-input"
          placeholder="Search saved filters"
          type="text"/>
      </div>
      <div class="list-names">
        @if (advancedFilterGroups?.length < 1) {
          <app-shared-button
            [disabled]="true"
            [fill]="false"
            [colour]="'clear'">
            <div>
              <span>Please Create Filter</span>
            </div>
          </app-shared-button>
        }
        @for (group of filteredAdvancedFilterGroups; track group.id) {
          <app-shared-button
            (buttonClicked)="onSelectedNameClick(group.id)"
            [disabled]="getIsNewAdvancedFilterGroup"
            [fill]="false"
            [matTooltip]="group.name"
            class="filter-list-item"
            colour="clear"
            matTooltipPosition="right">
            <div
              class="filter-list-item-content"
              [class.selected]="selectedAdvancedFilterGroup?.id === group.id"
              [class.applied]="group.id === appliedAdvancedFilterGroup?.id">
              <span class="filter-list-item-name">{{ group.name }}</span>
              <app-icon-chevron-right class="filter-list-item-chevron"></app-icon-chevron-right>
            </div>
          </app-shared-button>
        }
        @if (advancedFilterGroups?.length > 0 && filteredAdvancedFilterGroups?.length < 1) {
          <div class="list-no-results">No saved filters match your search.</div>
        }
      </div>
      <div class="list-add-actions">
        <app-shared-button
          (buttonClicked)="onNewItemClick()"
          [disabled]="getIsNewAdvancedFilterGroup"
          [fill]="false"
          class="add-new-button"
          colour="primary">
          Add New
        </app-shared-button>
        <span
          class="add-with-ai-tooltip"
          [matTooltip]="'Coming soon'"
          matTooltipPosition="right">
          <app-shared-button
            [disabled]="true"
            [fill]="false"
            class="add-with-ai-button"
            colour="clear">
            Add with AI
          </app-shared-button>
        </span>
      </div>
    </aside>

    @if (advancedFilterGroups?.length < 1 && !isAdvancedFiltersLoading && !selectedAdvancedFilterGroup) {
      <div class="no-select-text">
        <div>Advanced Filter Groups</div>
        <div class="divider"></div>
        <div>There are no saved Advanced Filter Groups saved.</div>
        <div>Please create one to start.</div>
      </div>
    }
    @if (advancedFilterGroups?.length > 0 && !selectedAdvancedFilterGroup && !isAdvancedFiltersLoading) {
      <div class="no-select-text">
        <div>Advanced Filter Groups</div>
        <div>There is no selection made for Advanced Filter Groups.</div>
        <div>Please make a selection to continue.</div>
      </div>
    }

    @if (selectedAdvancedFilterGroup) {
      <div class="editor-panel" [class.editor-panel--loading]="isAdvancedFiltersLoading">
        @if (isAdvancedFiltersLoading) {
          <div class="editor-loading-overlay" aria-live="polite" aria-busy="true">
            <app-shared-loading-g [animation]="animation"></app-shared-loading-g>
          </div>
        }
        <div class="filter-name-bar">
          <input
            (change)="onNameChange()"
            [(ngModel)]="selectedAdvancedFilterGroup.name"
            class="filter-name-input"
            placeholder="Filter name…"
            type="text"/>
          @if (!selectedAdvancedFilterGroup.saved) {
            <span class="unsaved-badge">Unsaved</span>
          }
          <span class="filter-meta">
            {{ getFilterGroupCount(selectedAdvancedFilterGroup) }} group{{ getFilterGroupCount(selectedAdvancedFilterGroup) !== 1 ? 's' : '' }}
            · {{ getConditionCount(selectedAdvancedFilterGroup) }} cond.
          </span>
          <div class="filter-name-actions">
            <app-shared-button
              (buttonClicked)="onCloneItemClick()"
              [disabled]="!selectedAdvancedFilterGroup.saved || isAdvancedFiltersLoading"
              [fill]="false"
              colour="clear">
              <app-icon-content-copy [tooltip]="'Clone - ' + selectedAdvancedFilterGroup.name"></app-icon-content-copy>
            </app-shared-button>
            <app-shared-button
              (click)="onDeleteAdvancedFilterGroupClick()"
              [disabled]="isAdvancedFiltersLoading"
              [fill]="false"
              colour="clear">
              <app-icon-delete-outline [tooltip]="'Delete - ' + selectedAdvancedFilterGroup.name"></app-icon-delete-outline>
            </app-shared-button>
          </div>
        </div>

        <div class="form-list">
          <app-shared-modal-filters-advanced-root
            [setColDef]="colDefsNames"
            [setContainerGroup]="(selectedGroupData$ | ngrxPush)">
          </app-shared-modal-filters-advanced-root>
        </div>

        <footer class="editor-footer">
          @if (!selectedAdvancedFilterGroup.saved) {
            <app-shared-button
              (buttonClicked)="onCancelItemClick()"
              [disabled]="isAdvancedFiltersLoading"
              [fill]="false"
              [colour]="'danger'">
              <app-display-icon
                [tooltip]="'Discard changes on - ' + selectedAdvancedFilterGroup.name"
                [colour]="iconColourEnum.red"
                [icon]="icons.cancel">
              </app-display-icon>
              Discard
            </app-shared-button>
          }
          <span class="footer-spacer"></span>
          @if (!selectedAdvancedFilterGroup.saved) {
            <app-shared-button
              (click)="onSaveItemClick()"
              [disabled]="isAdvancedFiltersLoading"
              [fill]="false"
              [colour]="'success'">
              <app-display-icon
                [tooltip]="'Save - ' + selectedAdvancedFilterGroup.name"
                [colour]="iconColourEnum.green"
                [icon]="icons.contentSaveOutline">
              </app-display-icon>
              Save
            </app-shared-button>
          }
          @if (!lockCategoryTabs && selectedAdvancedFilterGroup?.id !== appliedAdvancedFilterGroup?.id) {
            <app-shared-button
              (buttonClicked)="onApplyFilterClick()"
              [disabled]="isAdvancedFiltersLoading"
              [fill]="true">
              <app-display-icon
                [tooltip]="'Apply ' + selectedAdvancedFilterGroup.name + ' to grid'"
                [colour]="iconColourEnum.black"
                [icon]="icons.filterVariantPlus">
              </app-display-icon>
              Apply to Grid
            </app-shared-button>
          }
          @if (!lockCategoryTabs && selectedAdvancedFilterGroup?.id === appliedAdvancedFilterGroup?.id) {
            <app-shared-button
              (click)="onRemoveFilterClick()"
              [disabled]="isAdvancedFiltersLoading"
              [fill]="true">
              <app-display-icon
                [tooltip]="'Remove ' + selectedAdvancedFilterGroup.name + ' on grid'"
                [colour]="iconColourEnum.black"
                [icon]="icons.filterVariantRemove">
              </app-display-icon>
              Remove from Grid
            </app-shared-button>
          }
        </footer>
      </div>
    } @else if (isAdvancedFiltersLoading) {
      <div class="loading-indication-afg">
        <div>
          <app-shared-loading-g [animation]="animation"></app-shared-loading-g>
        </div>
      </div>
    }

  </div>

</div>
